/* eslint react/no-multi-comp: 0 */

import React from 'react';
import { Section } from 'spectacle-ppa';

import videoSlide from '../../baseSlides/videoSlide';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileLevel1 from './level1_egstory.md';
import markdownFileLevel2 from './level2_egstory.md';
import markdownFileLevel3 from './level3_egstory.md';
import markdownFileLevel4 from './level4_egstory.md';

const levels = {
  '1': { md: new MarkdownScript(markdownFileLevel1) },
  '2': { md: new MarkdownScript(markdownFileLevel2) },
  '3': { md: new MarkdownScript(markdownFileLevel3) },
  '4': { md: new MarkdownScript(markdownFileLevel4) }
};

function esOpeningStory ({ level, regionData }) {
  const md = levels[level].md;
  return (
    <Section id={"esGooberStory"}>

      {/* Esmerelada and Goober Story Intro */}
      { (level === 1) &&
        videoSlide({
          id: 'es-goober-intro',
          notes: md.getSubSectionAsHtml('Esmeralda and Goober Intro', 'Notes', false, regionData),
          youTubeId: md.getSectionMetadata('Esmeralda and Goober Intro', 'YouTube', regionData)
        })
      }

      {/* Sharknado in Level 3 */}
      { (level === 3) &&
        videoSlide({
          id: 'sharknado',
          notes: md.getSubSectionAsHtml('Sharknado', 'Notes', false, regionData),
          youTubeId: md.getSectionMetadata('Sharknado', 'YouTube', regionData)
        })
      }

      {/* Calming breath recap in Level 3 */}
      { (level === 3) &&
        videoSlide({
          id: 'calming-breath-recap',
          notes: md.getSubSectionAsHtml('Calming Breath Recap', 'Notes', false, regionData),
          youTubeId: md.getSectionMetadata('Calming Breath Recap', 'YouTube', regionData)
        })
      }

      {/* Esmerelda and Goober Story  */}
      {videoSlide({
        id: 'story',
        notes: md.getSubSectionAsHtml('Esmeralda and Goober Story', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Esmeralda and Goober Story', 'YouTube', regionData)
      })}

      {/* Calming breath intro in Level 2 */}
      { (level === 2) &&
        videoSlide({
          id: 'calming-breath',
          notes: md.getSubSectionAsHtml('Calming Breath Intro', 'Notes', false, regionData),
          youTubeId: md.getSectionMetadata('Calming Breath Intro', 'YouTube', regionData)
        })
      }

    </Section>
  );
}


export default esOpeningStory;



// WEBPACK FOOTER //
// ./programs/epsIntermediates/sections/11_esGooberStory/esGooberStorySection.jsx